// Lao translations
export const lo: Record<string, string> = {
  'menu.dashboard': 'ແຜງຄວບຄຸມ',
  'menu.customers': 'ລູກຄ້າ',
  'menu.products': 'ຜະລິດຕະພັນ',
  'menu.users': 'ຜູ້ໃຊ້',
  'menu.settings': 'ການຕັ້ງຄ່າ',
  'menu.logout': 'ອອກ',
  'dashboard.title': 'ແຜງຄວບຄຸມ',
  'dashboard.newOrder': 'ຄຳສັ່ງໃໝ່',
  'order.title': 'ຄຳສັ່ງໃໝ່',
  'order.customer': 'ລູກຄ້າ',
  'order.products': 'ຜະລິດຕະພັນ',
  'order.total': 'ລວມ',
  'users.title': 'ຜູ້ໃຊ້',
  'users.name': 'ຊື່',
  'users.email': 'ອີເມວ',
  'common.yes': 'ແມ່ນ',
  'common.no': 'ບໍ່',
  'common.cancel': 'ຍົກເລີກ',
  'common.save': 'ບັນທຶກ',
  'common.search': 'ຊອກຫາ',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'ເຂົ້າສູ່ລະບົບ',
  'login.welcome': 'ຍິນດີຕ້ອນຮັບ, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'ອີເມວ',
  'signup.phone': 'ໂທລະສັບ',
  'menu.reportsAndAccounting': 'ລາຍງານ ແລະ ບັນຊີ',
  'menu.systemAndCommunication': 'ລະບົບ ແລະ ການສື່ສານ',
};